// The app runs entirely in the browser: MSAL needs the redirect hash and the
// API is reached from the client. Static Web Apps serves the built files and
// routes /api/* to the managed Functions app, so there is nothing to render or
// prerender on a server.
export const ssr = false;
export const prerender = false;
export const trailingSlash = 'ignore';
